<div class="notifier {{notification.type}}">
    <mat-icon class="icon">{{icon}}</mat-icon>
    <span class="message">{{notification.message}}</span>
</div>